import React, { memo, useEffect, useState } from "react";
import HttpHelper from '../service/httpService';

const MapContactUsSection = (props) => {

    const [MapAddress, setMapAddress] = useState();

    const getMapAddress = () => {
        HttpHelper.get("website/GetSettingData").then((response) => {
            if (response && response.data) {
                let mapAddress = response.data.filter((elem) => elem.name === (props.Address == "Address1" ? 'MapAddress1' : 'MapAddress2'));
                if (mapAddress && mapAddress.length > 0 && mapAddress[0].value)
                    setMapAddress(mapAddress[0].value);
                else
                    mapAddress = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1920.9048081804222!2d-149.88323042262715!3d61.21974225829458!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x56c896289d142305%3A0xa77ff019d8be1b16!2s201%20E%203rd%20Ave%2C%20Anchorage%2C%20AK%2099501%2C%20USA!5e0!3m2!1sen!2sin!4v1718970405057!5m2!1sen!2sin';
            }
        });
    }

    useEffect(() => {
        getMapAddress();
    }, []);

    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    {/* <!--Google Map Area Start--> */}
                    <div className="google-map-area section text-center">
                        <div className="container-fluid">
                            <div className="contact-map-area">
                                <iframe className="contact-map"
                                    src={MapAddress}
                                    allowFullScreen="" aria-hidden="false" tabIndex="0"></iframe>
                            </div>
                        </div>
                    </div>
                    {/* <!--Google Map Area Start--> */}
                </div>
            </div>

        </>
    )
}

export default memo(MapContactUsSection);